import { render, staticRenderFns } from "./VueInput.vue?vue&type=template&id=b4ccab6e&scoped=true&"
import script from "./VueInput.vue?vue&type=script&lang=js&"
export * from "./VueInput.vue?vue&type=script&lang=js&"
import style0 from "./VueInput.vue?vue&type=style&index=0&id=b4ccab6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ccab6e",
  null
  
)

export default component.exports